<template>
  <div class="container-table">
    <q-table
      data-cy="excepciones-table"
      :data="data"
      :columns="columns"
      row-key="id"
      :pagination.sync="pagination"
      :loading="isLoading"
    >
      <template v-slot:body-cell-relacionName="props">
        <q-td data-cy="relacion" key="relacionName" :props="props">
          {{ props.row[filter] }}
        </q-td>
      </template>
      <template v-slot:body-cell-aplicacionName="props">
        <q-td data-cy="aplicacion" key="aplicacionName" :props="props">
          {{ props.row.aplicacionName }}
        </q-td>
      </template>
      <template v-slot:body-cell-deleteAction="props">
        <q-td data-cy="eliminar" key="deleteAction" :props="props">
          <q-icon
            data-cy="delete-excepcion-icon"
            name="o_delete"
            style="color: #002f6c; font-size: 24px; cursor: pointer;"
            @click="triggerDelete(props.row)"
          />
        </q-td>
      </template>
    </q-table>
    <DialogDelete
      v-if="showDialogDelete && this.selectedRow"
      v-model="showDialogDelete"
      dataCy="delete-excepcion"
      :showIcon="true"
      :txtContainer="`¿Está seguro de eliminar la excepción de la ${this.columns[0].label} ${this.nameDelete} para la aplicación ${selectedRow.aplicacionName}?`"
      @save="deleteExcepcion()"
    />
  </div>
</template>
<script>
import { QTable, QTd } from 'quasar';
import Loading from '@/components/shared/mixins/Loading.js';
import Validation from '@/components/shared/mixins/Validation.js';
import Message from '@/components/shared/mixins/Message.js';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';

export default {
  components: {
    QTable,
    QTd,
    DialogDelete
  },
  mixins: [Validation, Loading, Message],
  props: {
    tituloRelacion: String,
    filterField: String,
    dataExcepciones: Array,
    isLoading: Boolean
  },
  watch: {
    dataExcepciones: {
      handler: function () {
        this.data = this.dataExcepciones;
      },
      immediate: true
    }
  },
  data () {
    return {
      filter: this.filterField,
      data: this.dataExcepciones,
      pagination: {
        rowsPerPage: 4
      },
      columns: [
        {
          name: 'relacionName',
          label: this.tituloRelacion,
          align: 'left',
          field: 'visible',
          sortable: true
        },
        {
          name: 'aplicacionName',
          label: 'Aplicación asignada',
          align: 'left',
          field: '',
          sortable: true
        },
        {
          name: 'deleteAction',
          label: 'Eliminar',
          align: 'center',
          field: '',
          sortable: false
        }
      ],
      selectedRow: null,
      nameDelete: null,
      showDialogDelete: false
    };
  },
  methods: {
    clearSelectedRow () {
      this.selectedRow = null;
    },
    closeDeleteModal () {
      this.showDialogDelete = false;
      this.clearSelectedRow();
    },
    triggerDelete (row) {
      this.nameDelete = row[this.filterField];
      this.selectedRow = row;
      this.showDialogDelete = true;
    },
    deleteLocallyFromTable () {
      this.data.splice(this.data.indexOf(this.selectedRow), 1);
    },
    async deleteExcepcion () {
      let existId = this.selectedRow.hasOwnProperty('id');
      if (!existId) {
        this.deleteLocallyFromTable();
        this.closeDeleteModal();
        return;
      }

      const idExcepcion = this.selectedRow.id;

      let request = {
        controller: `/Servicio/Excepcion/${idExcepcion}`,
        filter: {}
      };

      await this.$store
        .dispatch('PF/deleteSuit', request)
        .then(() => {
          this.showMessage(`Se ha eliminado con éxito la excepción.`);
          this.deleteLocallyFromTable();
        })
        .catch((err) => {
          this.showError(err.message);
        })
        .finally(() => {
          this.closeDeleteModal();
        });
    }
  }
};
</script>
<style lang="scss" scoped></style>
